import React from 'react';
import { Route } from 'react-router-dom';

// Components.
import AuthClearContainer from 'containers/AuthClearContainer';

export default class AuthNotRequireClearContainer extends React.Component {

  static defaultProps = {
    isFree: false,
  };

  render() {
    const {
      component: Component,
      title,
      theme,
      additionTitle,
      ...props
    } = this.props;
    return (
      <Route
        {...props}
        render={props =>
          (
            <AuthClearContainer title={title} additionTitle={additionTitle} theme={theme} >
              <Component />
            </AuthClearContainer>
          )
        }
      />
    )
  }

}
